import { useTranslation } from 'react-i18next';
import styles from './checkoutLayout.module.scss';
import { EditIcon } from './icons';

export function MailStep({
  email,
  error,
  canContinue,
  onEmailChange,
  onContinue,
}: {
  email: string;
  error: string | null;
  canContinue: boolean;
  onEmailChange: (value: string) => void;
  onContinue: () => void;
}) {
  const { t } = useTranslation();

  return (
    <section className={styles.step}>
      <h2 className={styles.stepTitle}>{t('Mail')}</h2>
      <div className={styles.mailInner}>
        <label className={styles.field}>
          <span className={styles.fieldLabel}>{t('Contact')}</span>
          <input
            className={styles.input}
            type="email"
            placeholder={t('email')}
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
          {error && <div className={styles.fieldError}>{error}</div>}
        </label>
      </div>
      <button
        type="button"
        disabled={!canContinue}
        className={styles.mailBtn}
        onClick={onContinue}
      >
        {t('Continue with payment details')}
      </button>
    </section>
  );
}

export function MailSummary({
  email,
  name,
  isLoggedIn,
  onEdit,
}: {
  email: string;
  name?: string;
  isLoggedIn: boolean;
  onEdit: () => void;
}) {
  const { t } = useTranslation();

  return (
    <section className={styles.step}>
      <div className={styles.stepHead}>
        <h2 className={styles.stepTitle}>{t('Mail')}</h2>
        <button type="button" className={styles.editBtn} onClick={onEdit}>
          <EditIcon className={styles.editIcon} />
          {isLoggedIn ? t('switch user') : t('edit')}
        </button>
      </div>
      <div className={styles.mailSummary}>
        <div className={styles.mailSummaryName}>{name || ' '}</div>
        <div className={styles.mailSummaryEmail}>{email}</div>
      </div>
    </section>
  );
}
